import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { FieldOperationsListingFiltersSourceService } from './field-operations-listing-filters-source.service';
import { FieldOperationsListingDataSourceService } from './field-operations-listing-data-source.service';
import { FieldOperationsListingExportConfigService } from './field-operations-listing-export-config.service';
import { FieldOperationsServiceServiceListingModelService } from './field-operations-listing-model.service';

export const provideFieldOperationsListing = (): (Provider | EnvironmentProviders)[] => [
  FieldOperationsListingFiltersSourceService,
  FieldOperationsListingDataSourceService,
  FieldOperationsListingExportConfigService,
  { provide: LISTING_MODEL, useClass: FieldOperationsServiceServiceListingModelService },
  ListingPageService,
  QueryParamsHandlerService
];
